/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Subtitle_Max_Chars_LabelInputs */



/**
* | output |
* | --- |
* | "Maximum Characters" |
*
* @param {Audio_Description_Export_Subtitle_Max_Chars_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_subtitle_max_chars_label = /** @type {((inputs?: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Subtitle_Max_Chars_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre maximal de caractères")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Zeichenanzahl")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero massimo di caratteri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальное количество символов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximo de caracteres")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最大字符数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大文字数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम अक्षर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número máximo de caracteres")
	return /** @type {LocalizedString} */ ("Maximum Characters")
});